import React from 'react';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import Chip from '@mui/material/Chip';
import DialogTitle from '@mui/material/DialogTitle';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import serverApi from '../../api/server'
import { Typography } from 'antd';
const {Text} = Typography;
interface Merchant {
    Name: string;
    Description: string;
    Tags: string[];
}
function AddMerchant({openAddMerchant, handleCloseAddMerchant, update, setUpdate} : any) {
    const [newMerchant, setNewMerchant] = React.useState<Merchant>();
    const [inputTag, setInputTag] = React.useState<string>('');
    const [selectedTags, setSelectedTags] = React.useState<string[]>([]);
    const [warning, setWarning] = React.useState(false);
    const [warningMsg, setWarningMsg] = React.useState('')
    const handleChange = (type: any, event: any) => {
        let updateMerchant = Object.assign({}, newMerchant)
        if(type === 'name') {
            updateMerchant.Name = event.target.value
            setNewMerchant(updateMerchant)
        }
        else if(type === 'description') {
            updateMerchant.Description = event.target.value
            setNewMerchant(updateMerchant)
        }
        else if(type === 'tags') {
            console.log(event.target.value)
            // updateMerchant.Tags = event.target.value
            // setCurAsset(updateAsset)
        }
    }
    const inputChange = (event: any) => {
        setInputTag(event.target.value)
    };
    const handleSelectTagsKeyDown = ({key} : any) => {
        if(key === 'Enter') {
            let tagArr = [...selectedTags]
            if(tagArr.length >= 5) {
                setWarning(true)
                setWarningMsg("Max tag limit(5) has been reached!")
            }
            else {
                if(!tagArr.includes(inputTag)){
                    tagArr.push(inputTag)
                    setSelectedTags(tagArr)
                }
                setInputTag("")
            }
        }
    }
    const handleDeleteTagInput = (item: string) => {
        let tagArr = [...selectedTags]
        let position = tagArr.indexOf(item)
        tagArr.splice(position, 1)
        setSelectedTags(tagArr)
    }
    const handleCreateNewMerchant = async() => {
        try{
            const jsonData = {
                name: newMerchant?.Name,
                description: newMerchant?.Description,
                tags: selectedTags
            };
            console.log(jsonData)
            // const timeStamp = moment().seconds(0).milliseconds(0).toISOString().slice(0, -1) + "000Z"
            // const path = 'api/updateClient' 

            //const signature = generateSignature("POST", timeStamp, path, null, jsonData) 

            const res = await serverApi.post(`/addMerchant`, jsonData, 
                //{headers: {Authorization: signature}}
            )
            console.log(res)
            if(res){
                let count = update + 1
                setUpdate(count)
                setSelectedTags([])
                setNewMerchant(undefined)
                handleCloseAddMerchant()

            }
        }
        catch(err){
            console.log(err)
            setWarning(true)
            setWarningMsg("Error: Creating Merchant - " + err)
        }
    }
    return (
        <>
        <Dialog open={openAddMerchant} onClose={handleCloseAddMerchant} maxWidth={'md'} fullWidth={true}>
            <DialogTitle>New Merchant</DialogTitle>
            <DialogContent>
                <div className='dialogRow'>
                    <Text className='label' strong>Merchant Name: </Text>
                    <TextField 
                        id="standard-basic" 
                        variant="standard" 
                        value={newMerchant?.Name} 
                        onChange={(e) => handleChange('name', e)}/>
                </div>
                <div className='dialogRow'>
                    <Text className='label' strong>Description: </Text>
                    <TextField
                        id="outlined-multiline-static"
                        // label="Wallet Address"
                        variant="standard" 
                        sx={{width: '60%'}}
                        value={newMerchant?.Description}
                        onChange={(e) => handleChange('description', e)}
                    />
                </div>
                <div className='dialogRow'>
                    <Text className='label' strong>Tags: </Text>
                    <TextField
                            fullWidth
                            variant="outlined"
                            label="Tags"
                            // multiline
                            value={inputTag}
                            onChange={inputChange}
                            onKeyDown={handleSelectTagsKeyDown}
                            // multiline
                            InputProps={{
                                startAdornment: 
                                selectedTags.map((item: string) => (
                                        <Chip
                                            key={item}
                                            label={item}
                                            sx={{marginRight: 1}}
                                            onDelete={() => handleDeleteTagInput(item)}
                                        />
                                    ))
                            }}
                        />
                </div>
            </DialogContent>
            <DialogActions>
            <Button onClick={handleCloseAddMerchant}>Cancel</Button>
            <Button onClick={handleCreateNewMerchant} disabled={!newMerchant?.Name || !newMerchant.Description}>Create</Button>
            </DialogActions>
        </Dialog>
        <Snackbar open={warning} autoHideDuration={6000} onClose={() => setWarning(false)}>
            <Alert severity="warning">{warningMsg}</Alert>
        </Snackbar>
        </>
    );
}

export default AddMerchant;